module.exports = __webpack_public_path__ + "img/icon_group_manage.635c0ff3.svg";